import {forwardRef} from 'react';

import {Input} from 'Input';

import {InputChips} from '../InputChips';
import {WrapInputEditable} from '../WrapInput';
import {NoWrapInput} from '../NoWrapInput';

import {useEditableInput} from './hook';

import type {InputProps} from 'Input';

export const EditableInput = forwardRef<HTMLInputElement, Omit<InputProps, 'value' | 'onChange'>>((props, ref) => {
  const {inputProps, multiple, wrap} = useEditableInput(props);

  let inputComponent = wrap ? WrapInputEditable : NoWrapInput;

  if (multiple) {
    inputComponent = InputChips;
  }

  return <Input ref={ref} inputComponent={inputComponent} {...inputProps} />;
});
